import Cookies from 'js-cookie'
import { getUrlKey } from '@/utils/index' // 获取url参数
var versions = 'V4'
export function getLogin() {
  if (Cookies.get('id' + getUrlKey('wxKey') + versions)) {
    var value = Cookies.get('id' + getUrlKey('wxKey') + versions).replace(/(^\s*)|(\s*$)/g, '')
    return value
  } else {
    return Cookies.get('id' + getUrlKey('wxKey') + versions)
  }
}

export function setLogin(val, time) {
  return Cookies.set('id' + getUrlKey('wxKey') + versions, val, {
    expires: time
  })
}

export function outLogin() {
  return Cookies.remove('id' + getUrlKey('wxKey') + versions)
}

export function setUserName(val) {
  return Cookies.set('userName', val)
}

export function getUserName(val) {
  return Cookies.get('userName')
}

export function setLock() {
  return Cookies.set('DISCIPLES_LOCK', 'LOCK', '1D')
}

export function getLock() {
  return Cookies.get('DISCIPLES_LOCK')
}

export function outLock() {
  return Cookies.remove('DISCIPLES_LOCK')
}
